import React from "react"
import {
    BooleanField,
    BooleanInput,
    ChipField,
    Datagrid,
    Filter,
    FunctionField,
    List,
    NumberInput,
    ReferenceField,
    TextField,
    useRecordContext,
} from "react-admin"
import ArtTrackIcon from "@mui/icons-material/ArtTrack"
import moment from "moment"
import { Link } from "react-router-dom"
import { Button } from "@mui/material"

const DynamicImageFilter = props => {
    return (
        <Filter {...props}>
            <NumberInput label="Company ID" source="company_id" alwaysOn />
            <BooleanInput source="hide_internal_users" label="Hide internal users" defaultValue="true" />
        </Filter>
    )
}

const BannersShowButton = () => {
    const record = useRecordContext()
    return (
        <Button
            component={Link}
            size="small"
            color="primary"
            variant="contained"
            startIcon={<ArtTrackIcon />}
            to={{
                pathname: "/banner_builder",
                search:
                    "filter=" +
                    JSON.stringify({
                        template_ids: record.template_id,
                    }),
            }}>
            Banners
        </Button>
    )
}

export const DynamicImageList = props => (
    <List {...props} filters={<DynamicImageFilter />} exporter={false} sort={{ field: "id", order: "DESC" }}>
        <Datagrid bulkActionButtons={false}>
            <FunctionField label="ID" sortBy="id" render={record => `#${record.id}`} />
            <TextField source="uuid" sortable={false} />
            <TextField source="name" sortable={false} />
            <ReferenceField label="Template" source="template_id" reference="templates" link="show" sortable={false}>
                <ChipField source="name" />
            </ReferenceField>
            <ReferenceField label="Company" source="company_id" reference="companies" link="show" sortable={false}>
                <ChipField source="name" />
            </ReferenceField>
            <BooleanField source="is_active" />
            <BooleanField source="rate_limit" />
            <FunctionField label="Created date" sortBy="created_at_ts" render={record => moment(record.created_at_ts * 1000, "x").format("DD/MM/YYYY")} />
            <FunctionField
                label="Expiration date"
                sortBy="expiration_at_ts"
                render={record => (record.expiration_at_ts ? moment(record.expiration_at_ts * 1000, "x").format("DD/MM/YYYY") : "-")}
            />
            <BannersShowButton />
        </Datagrid>
    </List>
)
